import React, {Component} from 'react';

import swal from 'sweetalert2';
import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import {ajaxHandler} from "../../../../utils/errors";
import helpers from "../../../../utils/helpers";

export default class ProductDelete extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ajaxInProgress: false
        };
    }

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let data = {
            active: false,
            code: this.props.item.code,
            name: this.props.item.name,
        };

        const DELETE_PRODUCT = `${urls.API_ROOT}/api/v1/product/id/${this.props.item.id}/`;
        axios.put(`${DELETE_PRODUCT}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(ajaxHandler);
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});

        swal({
            title: `Producto desactivado`,
            html: 'El producto ha sido desactivado correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    render() {

        // F&E do not delete
        if(this.props.item.trip_type === helpers.trip_type.FE){
            return (
                <div className={"admin-modal"}>
                    <div className={"row"}>
                        <h3 className={"center"}>Eliminar Producto</h3>
                    </div>
                    <div className={"row"}>
                        <div className={"col s12 input-field"} style={{height: 200}}>
                            <p>Este es un producto de viajes Fame & Ethanol, y <b>no puede eliminarse</b></p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s12 center"}>
                            <button
                                className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                                onClick={this.props.closeAction}
                            >Volver</button>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>Eliminar Producto</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"} style={{height: 200}}>
                        <p>
                            Usted esta por desactivar al producto <b>{this.props.item.name}</b>.
                            Esta acción no puede deshacerse. ¿Desea continuar?
                        </p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Continuar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/ProductDelete.js